import { StyleSheet } from '@react-pdf/renderer';

export const pdfStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 28,
    fontFamily: 'Helvetica'
  },
  header: {
    marginBottom: 18,
    borderBottomWidth: 1,
    borderBottomColor: '#cfd8e3',
    paddingBottom: 12
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  logoWrap: {
    width: 120,
    flexDirection: 'row',
    alignItems: 'center'
  },
  logoImage: {
    width: 64,
    height: 64,
    objectFit: 'contain'
  },
  headerTitleBlock: {
    flex: 1,
    alignItems: 'center'
  },
  title: {
    fontSize: 22,
    textAlign: 'center',
    color: '#0d3b66',
    fontWeight: 'bold'
  },
  subtitle: {
    marginTop: 4,
    fontSize: 10,
    textAlign: 'center',
    color: '#5f6c7c'
  },
  inputTable: {
    borderWidth: 1,
    borderColor: '#cfd8e3',
    overflow: 'hidden',
    marginBottom: 14
  },
  inputRow: {
    flexDirection: 'row'
  },
  inputCell: {
    width: '50%',
    borderRightWidth: 1,
    borderRightColor: '#d0d7de',
    borderBottomWidth: 1,
    borderBottomColor: '#d0d7de',
    paddingVertical: 5,
    paddingHorizontal: 9
  },
  inputCellLastInRow: {
    borderRightWidth: 0
  },
  inputRowLast: {
    borderBottomWidth: 0
  },
  inputLabel: {
    fontSize: 9,
    textTransform: 'uppercase',
    color: '#6c757d'
  },
  inputValue: {
    marginTop: 2,
    fontSize: 11,
    fontWeight: 'bold',
    color: '#1b1f24'
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 16
  },
  summaryCard: {
    minWidth: 180,
    paddingVertical: 8,
    paddingHorizontal: 20,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#cfd8e3',
    backgroundColor: '#f5f7fa',
    alignItems: 'center'
  },
  summaryLabel: {
    fontSize: 9,
    color: '#6c757d',
    textTransform: 'uppercase'
  },
  summaryValue: {
    marginTop: 3,
    fontSize: 15,
    fontWeight: 'bold',
    color: '#1b1f24'
  },
  tableSection: {
    flex: 1,
    marginBottom: 14
  },
  tableSectionLeft: {
    marginRight: 8
  },
  tableSectionRight: {
    marginLeft: 8
  },
  tablesRow: {
    flexDirection: 'row'
  },
  tableTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#0d3b66',
    marginBottom: 4,
    textTransform: 'uppercase'
  },
  tableContainer: {
    borderWidth: 1,
    borderColor: '#cfd8e3',
    overflow: 'hidden'
  },
  tableHeaderRow: {
    flexDirection: 'row',
    backgroundColor: '#eef2f7',
    borderBottomWidth: 1,
    borderBottomColor: '#cfd8e3'
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#edf2f7'
  },
  tableRowAlt: {
    backgroundColor: '#f6f8fb'
  },
  metricCellWrap: {
    flex: 1.3,
    borderRightWidth: 1,
    borderRightColor: '#cfd8e3',
    paddingVertical: 6,
    paddingHorizontal: 9,
    justifyContent: 'center'
  },
  valueCellWrap: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#cfd8e3',
    paddingVertical: 6,
    paddingHorizontal: 6,
    justifyContent: 'center',
    alignItems: 'center'
  },
  valueCellLast: {
    borderRightWidth: 0
  },
  headerPrimary: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1b1f24',
    textAlign: 'center'
  },
  headerSecondary: {
    fontSize: 8,
    color: '#6c757d',
    textAlign: 'center'
  },
  metricLabel: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#495057'
  },
  cellValue: {
    fontSize: 9,
    color: '#1b1f24',
    textAlign: 'center'
  },
  alertBox: {
    borderWidth: 1,
    borderColor: '#f0c36d',
    backgroundColor: '#fff7e1',
    padding: 8,
    borderRadius: 6,
    marginBottom: 12
  },
  alertTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#b36a00',
    marginBottom: 4
  },
  alertItem: {
    fontSize: 8.5,
    color: '#8b5200',
    marginBottom: 2,
    lineHeight: 1.2
  },
  footer: {
    marginTop: 'auto',
    borderTopWidth: 1,
    borderTopColor: '#cfd8e3',
    paddingTop: 10,
    fontSize: 9,
    color: '#5f6c7c',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  footerLink: {
    color: '#0d3b66',
    textDecoration: 'none'
  },
  shearSection: {
    marginTop: 14,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: '#f0c36d',
    borderRadius: 4,
    padding: 10,
    backgroundColor: '#fffdf5'
  },
  shearSectionTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#6d4c00',
    textTransform: 'uppercase',
    marginBottom: 8
  },
  shearInputRow: {
    flexDirection: 'row',
    marginBottom: 6
  },
  shearInputCell: {
    flex: 1,
    paddingVertical: 4,
    paddingHorizontal: 6,
    backgroundColor: '#fff8e6',
    borderRadius: 3,
    marginRight: 4
  },
  shearOutputRow: {
    flexDirection: 'row',
    marginTop: 4
  },
  shearOutputCell: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: '#f5f7fa',
    borderRadius: 4,
    marginRight: 4,
    alignItems: 'center'
  },
  shearOutputCellWarning: {
    backgroundColor: '#fff3cd',
    borderWidth: 1,
    borderColor: '#f0c36d',
    marginRight: 0
  },
  shearOutputLabel: {
    fontSize: 8,
    color: '#6c757d',
    textTransform: 'uppercase',
    textAlign: 'center',
    marginBottom: 2
  },
  shearOutputValue: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#1b1f24',
    textAlign: 'center'
  },
  shearWarningValue: {
    color: '#6d4c00'
  },
  shearWarningNote: {
    fontSize: 7.5,
    color: '#8b6200',
    textAlign: 'center',
    marginTop: 2
  }
});
